import { Link } from 'react-router-dom';

import { useTenant } from '@/providers/tenant-context';

type AuthPolicyNoticeProps = {
  variant: 'login' | 'register';
};

export function AuthPolicyNotice({ variant }: AuthPolicyNoticeProps) {
  const { tenant, isWhitelabel } = useTenant();
  const serviceName = isWhitelabel && tenant?.name ? tenant.name : 'Milora';

  const intro =
    variant === 'login'
      ? `By logging in and using the services of ${serviceName}, you agree to comply with our`
      : `By creating an account and using the services of ${serviceName}, you agree to comply with our`;

  return (
    <p className="mt-6 text-center text-xs leading-relaxed text-muted-foreground">
      {intro}{' '}
      <Link to="/privacy" className="font-medium text-primary hover:underline">
        Privacy Policy
      </Link>{' '}
      and{' '}
      <Link to="/terms" className="font-medium text-primary hover:underline">
        Terms and Conditions
      </Link>
      .
    </p>
  );
}
